import React from 'react'
import {
  Modal,
  ModalHeader,
  ModalBody,
  ModalFooter,
  Label,
} from 'reactstrap'
import get from 'lodash/get'
import styled from 'styled-components'

class ModalMessage extends React.Component {
  render() {
    return (
      <Modal
        isOpen={ get(this.props, 'show') }
        toggle={ get(this.props, 'hide') }
      >
        <ModalHeader toggle={ get(this.props, 'hide') }>
          <Head>
            { get(this.props, 'type') === 200 ? 'Success' : get(this.props, 'type') }
          </Head>
        </ModalHeader>
        {
          get(this.props, 'flag') === 'confirmImport' &&
          <NewModalBody>
            <span>Created: </span><span>{ get(this.props, 'created') }</span>
            <br />
            <span>Updated: </span><span>{ get(this.props, 'updated') }</span>
            <br />
            <span>Errors: </span><span>{get(this.props, 'errors.length', 0)}</span>
            { get(this.props, 'errors', []).map((item, key) => {
              return <li>{ item }</li>
            }) }
          </NewModalBody>
        }
        {
          get(this.props, 'flag') !== 'confirmImport' &&
          <ModalBody>
            <NormalLabel>{ get(this.props, 'message') }</NormalLabel>
          </ModalBody>
        }
        <ModalFooter>
          { get(this.props, 'button') }
        </ModalFooter>
      </Modal>
    )
  }
}

export default ModalMessage

const NewModalBody = styled(ModalBody)`
  overflow-y:auto;
  max-height:200px;
  font-family: 'Gotham' !important;
  font-size: 14px ;
`
const NormalLabel = styled(Label)`
  font-family: 'Gotham' !important;
  font-size: 16px ;
`
const Head = styled(Label)`
  font-family: 'Gotham-Bold' !important;
  font-size: 16px ;
  color:#AD2624 ;
`



// WEBPACK FOOTER //
// ./src/components/modal-message/index.js